import React, { Component } from "react";
import DatePicker, { DateObject } from "react-multi-date-picker";

const MONTH_MAP = {
  Januari: 0,
  Februari: 1,
  Maret: 2,
  April: 3,
  Mei: 4,
  Juni: 5,
  Juli: 6,
  Agustus: 7,
  September: 8,
  Oktober: 9,
  November: 10,
  Desember: 11,
};

export const convertToDateObject = (monthYearString) => {
  const [monthName, year] = monthYearString.split(" ");
  const month = MONTH_MAP[monthName];
  const date = new Date(year, month, 1);
  return new DateObject(date);
};

class SimpleMonthYearPickerWithIcon extends Component {
  render() {
    const {
      label,
      mandatory,
      errorMessage,
      id,
      value,
      readOnly,
      onChange,
      placeholder,
      onlyYearPicker,
      ...rest
    } = this.props;

    let displayValue = "";

    if (value && typeof value.format === "function") {
      displayValue = onlyYearPicker
        ? value.format("YYYY")
        : value.format("MMMM YYYY");
    }
    
    return (
      <div
        className={`margin-bottom-20px ${
          this.props.containerclassname ? this.props.containerclassname : ""
        }`}
      >
        {label || mandatory ? (
          <div className="margin-5px">
            <div className="txt-site txt-11 txt-main txt-bold">
              <h4>
                {label} {mandatory && <span style={{ color: "red" }}>*</span>}
              </h4>
            </div>
          </div>
        ) : null}
        <div>
          <DatePicker
            onlyMonthPicker
            locale={{
              months: [
                ["Januari", "January"],
                ["Februari", "February"],
                ["Maret", "March"],
                ["April", "April"],
                ["Mei", "May"],
                ["Juni", "June"],
                ["Juli", "July"],
                ["Agustus", "August"],
                ["September", "September"],
                ["Oktober", "October"],
                ["November", "November"],
                ["Desember", "December"],
              ],
              digits: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
            }}
            // render={(_, openCalendar) => (
            //   <div role="button" onClick={openCalendar}>
            //     <input
            //       id={id}
            //       className="txt txt-sekunder-color"
            //       style={{ backgroundColor: readOnly && "#E6E6E6" }}
            //       disabled={readOnly}
            //       value={displayValue}
            //       placeholder={placeholder || "MMMM YYYY"}
            //     />
            //   </div>
            // )}
            render={(_, openCalendar) => (
              <div
                role="button"
                onClick={openCalendar}
                style={{ position: "relative" }}
              >
                <input
                  id={id}
                  className="txt txt-sekunder-color"
                  style={{
                    backgroundColor: readOnly && "#E6E6E6",
                    paddingRight: "35px",
                  }}
                  disabled={readOnly}
                  value={displayValue}
                  placeholder={placeholder || "MMMM YYYY"}
                />
                <i
                  className="fa fa-calendar-alt"
                  aria-hidden="true"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "18px",
                    color: "#555",
                  }}
                />
              </div>
            )}
            value={value}
            onFocusedDateChange={onChange}
            onlyYearPicker={onlyYearPicker}
            {...rest}
          />
        </div>
        {mandatory && errorMessage && (
          <p className="txt-site txt-11 color-red margin-top-5px">
            {errorMessage}
          </p>
        )}
      </div>
    );
  }
}

export default SimpleMonthYearPickerWithIcon;
